import {useState} from "react";

import RegisterFormStep1 from "./RegisterFormStep1";
import RegisterFormStep2 from "./RegisterFormStep2";
import RegisterFormStep3 from "./RegisterFormStep3";
import RegisterFormStep4 from "./RegisterFormStep4";
import RegisterFormStep5 from "./RegisterFormStep5";

const RegisterForm = () => {
    const [step, setStep] = useState(1);
    const [data, setData] = useState({});

    return (
        <div className='w-100 text-center py-5'>
            {
                {
                    1: <RegisterFormStep1 onDone={(params) => {
                        setData(params);
                        setStep(2)
                    }}/>,
                    2: <RegisterFormStep2 email={data?.email || ''} onDone={(code) => {
                        setData({...data, code});
                        setStep(3);
                    }} back={() => setStep(1)}/>,
                    3: <RegisterFormStep3 params={data} email={data.email} code={data.code} back={() => setStep(2)} onDone={(password) => {
                        setData({...data, password});
                        setStep(4);
                    }}/>,
                    4: <RegisterFormStep4 email={data.email} password={data.password} code={data.code} back={() => setStep(3)} onDone={(res) => {
                        setStep(5);
                    }}/>,
                    5: <RegisterFormStep5 />
                }[step]
            }
        </div>
    )
}

export default RegisterForm;